import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import {FormGroup,FormsModule,Validators, FormControl} from '@angular/forms';
import { LoadService } from '../../services/load.service';
import { StockService } from '../../services/stock.service';
import { PalletsService } from '../../services/pallets.service';
import { LocationService } from '../../services/location.service';






@Component({
  selector: 'app-devolucion',
  templateUrl: './devolucion.component.html',
  styleUrls: ['./devolucion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DevolucionComponent implements OnInit {

public mostrarIngresarCaja:boolean;
public mostrarSeleccionarPallet:boolean;
public mostrarConfirmarDevolucion:boolean;
public mostrarAlert:boolean;

public pasoCaja:boolean;
public pasoPallet:boolean;
public pasoAsignarCajas:boolean;
public pasoConfirmar:boolean;
public esnuevo:boolean;
public permitirNuevoPallet:boolean;
public es_generica:boolean;


public isopen:boolean;
public alert:string;

public formBuscar:FormGroup;
public formPalletsDisponibles:FormGroup;
public formCambiarUbicacion:FormGroup;
public formCambiarPosicion:FormGroup;

public cajas:any[];
public pallet:any;

public palletsDisponibles:any[];
public palletsDisponiblesOrdenProduccion:any[];
public palletsSeleccionados:any[];
public palletsNuevos:any[];

public ubicaciones:any[];
public posicionesDisponibles:any[];
public posicionesUbicacionSeleccionada:any[];

public ordenProduccionActual:string;
public id_palletNuevo:number;

/*datos para imprimir codigo pallet*/
public myAngularxQrCode:string;
public codigo:string;
public cliente:string;

  constructor(private _loaddata:LoadService, private _stockService:StockService, private _palletsService:PalletsService, private _locationService:LocationService) {
    this.mostrarIngresarCaja = true;
    this.mostrarSeleccionarPallet = false;
    this.mostrarConfirmarDevolucion = false;
    this.mostrarAlert = false;

    this.pasoCaja = true;
    this.pasoPallet = false;
    this.pasoAsignarCajas = false
    this.pasoConfirmar = false;
    this.esnuevo = false;
    this.permitirNuevoPallet = true;
    this.es_generica = false;

    this.isopen = false;
    this.alert = '';

    this.cajas = [];
    this.pallet = '';
    this.palletsDisponibles = [];
    this.palletsDisponiblesOrdenProduccion = [];
    this.palletsSeleccionados = [];
    this.palletsNuevos = [];

    this.ubicaciones = [];
    this.posicionesDisponibles = [];
    this.posicionesUbicacionSeleccionada = [];

    this.ordenProduccionActual = '';
    this.id_palletNuevo = 0;

    this.myAngularxQrCode = 'P18-0000-PRUEBA';
    this.codigo = '';
    this.cliente = '';

    this.formBuscar = new FormGroup({
      'codigoCaja': new FormControl('', Validators.required)
    });

    this.formPalletsDisponibles = new FormGroup({
      'pallet': new FormControl('', Validators.required)
    });

    this.formCambiarUbicacion = new FormGroup({
      'ubicacion': new FormControl('', Validators.required)
    });

    this.formCambiarPosicion = new FormGroup({
      'posicion': new FormControl('', Validators.required)
    });
  }

  ngOnInit() {

    //this.cargarTodosPalletsConDisponibilidad();
    this.cargarUbicaciones();
  }

  cargarTodosPalletsConDisponibilidad(op:string){

    if(this.es_generica){
      this.alert = "Cargando Pallets Genéricos Disponibles";
      this.isopen = true;
      this._loaddata.loadChange(60);
      this._palletsService.getAllGenericPallets().subscribe((response:any)=>{
        for(let pallet of response.data){
          if(pallet.attributes.amount <= 89){
            this.palletsDisponibles.push(pallet);
          }
        }
        //this.palletsDisponibles = response.data;
        //console.log("Pallets Genéricos: ", this.palletsDisponibles);
        this.alert = "Carga Correcta de Pallets";
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      },(error)=>{
        //console.log("No se pudieron cargar los pallets genéricos");
      })
    }
    else{
      this.alert = "Cargando Pallets Disponibles con OP: "+op;
      this.isopen = true;
      this._loaddata.loadChange(60);
      //console.log("OP: ", this.ordenProduccionActual);
      this._palletsService.getAllByBoxes2(op).subscribe((response:any)=>{
         //console.log("RESPONSE: ", response);
          this.palletsDisponibles = response.data;
          //console.log("Pallets de OP: "+op, this.palletsDisponibles);
          this.alert = "Carga Correcta de Pallets";
          this.isopen = true;
          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
          //this.cargarUbicaciones();

        },
      (error)=>{
        //console.log("No se han cargado los pallets");
      });
    }

  }

  cargarUbicaciones(){
    this.alert = "Cargando Ubicaciones";
    this.isopen = true;
    this._loaddata.loadChange(30);
    this._locationService.get().subscribe(
      (response:any) => {
        this.ubicaciones = response.data;
        this.alert = "Ubicaciones Cargadas";
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
        //console.log("ubicaciones: ", this.ubicaciones);

        // for(let ubicacion of this.ubicaciones){
        //   //console.log("UBICACION: ", ubicacion);
        //   this._locationService.freePositionsFromLocation(ubicacion.id).subscribe((response:any) => {
        //     console.log("POSICION:", response);
        //     for(let pos of response.data){
        //
        //
        //       let posicion = {
        //
        //         'location_id':ubicacion.id,
        //         'position_id':pos.id,
        //         'nombre_posicion': pos.attributes.name,
        //         'nombre_ubicacion':ubicacion.attributes.name
        //       }
        //       // for(let ubicacion of this.ubicaciones){
        //       //   if(ubicacion.id == posicion.location_id){
        //       //     posicion.nombre_ubicacion = ubicacion.attributes.name;
        //       //   }
        //       // }
        //       this.posicionesDisponibles.push(posicion);
        //     }
        //     console.log("posiciones disponibles: ", this.posicionesDisponibles);
        //   },
        //   (error) => {
        //     console.log("No se han cargado las posiciones disponibles");
        //   });
        // }
      },
      (error) => {
        //console.log("No se han cargado las ubicaciones");
      }
    );
  }

  crearPalletNuevo(){

    for(let pal of this.palletsSeleccionados){
      if(pal.nuevo == true){
        this.permitirNuevoPallet = false;
      }
    }

    if(this.permitirNuevoPallet == true){
      //this.codigo = '';
      //console.log("CREANDO PALLET NUEVO");
      this.alert = 'Creando Un Pallet Nuevo';
      this.isopen = true;
      this._loaddata.loadChange(40);
      let prefijo = `P${this.ordenProduccionActual}`;
      this.id_palletNuevo = this.id_palletNuevo + 1;
      let pallet = {
        'pallet_id':this.id_palletNuevo,
        'prefijo':`P${this.ordenProduccionActual}`,
        'sufijo':'',
        'amount':0,
        'location':{
          'location_id':'',
          'position_id':'',
          'nombre_posicion':'',
          'nombre_ubicacion':'',
        },
        'numero':'',
        'cajas':[],
        'selected':false,
        'nuevo':true
      }

      this.palletsSeleccionados.push(pallet);

      this.alert = 'Pallet Nuevo Creado y agregado a la pantalla';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();

    /*CREANDO UN PALLET*/
      // let prov = this._palletsService.transformData4(prefijo);
      // //console.log("JSON NUEVO PALLET", prov);
      // this._palletsService.save(prov).subscribe((response:any)=>{
      //   console.log("RESPUESTA CREACIÓN DE PALLET: ",  response);
      //   this.myAngularxQrCode = response.attributes.qr_code;
      //   this.codigo = response.attributes.number;
      //   //this.codigo = response.attributes.number;
      //   this.palletsSeleccionados.push({
      //                                     'pallet_id': response.id,
      //                                     'amount': response.attributes.amount,
      //                                     'location_old':{
      //                                                       'location_id':'',
      //                                                       'position_id':'',
      //                                                       'nombre_posicion': '',
      //                                                       'nombre_ubicacion':''
      //                                                   },
      //                                     'location':{
      //                                                   'location_id':'',
      //                                                   'position_id':'',
      //                                                   'nombre_posicion': '',
      //                                                   'nombre_ubicacion':''
      //                                                },
      //                                     'numero':response.attributes.number,
      //                                     'cajas':[],
      //                                     'selected':false,
      //                                     'nuevo':true
      //                                   });
      //   console.log("PALLETS DISPONIBLES AL CREAR: ", this.palletsSeleccionados);
      //
      //   /*por alguna razón se debe setear el that con el this ya que agarra toda la pagina al imprimir*/
      //   let that = this;
      //   setTimeout(function(){
      //     that.print();
      //   },100);
      //
      //   this.alert = 'Pallet Nuevo Creado y agregado a la pantalla';
      //   this.isopen = true;
      //   this._loaddata.loadChange(100);
      //   this.onClosedAutomatic();
      //
      //   },error=>{
      //     console.log("No se creó el pallet");
      //     this.alert = 'No se ha creado el pallet';
      //     this.isopen = true;
      //     this._loaddata.loadChange(100);
      //     this.onClosedAutomatic();
      // });

      //console.log("PALLETS AL CREAR: ", this.palletsSeleccionados);
    }

  }

  onCambiarUbicacion(){
    this.alert = "Cargando Posiciones Disponibles";
    this.isopen = true;
    this._loaddata.loadChange(30);
    this.posicionesUbicacionSeleccionada = [];
    let ubi = this.formCambiarUbicacion.get('ubicacion').value;
    let ubicacion =  this.ubicaciones.filter(function(ubicacion) {
           return ubicacion.id === ubi;
         })[0];

    this._locationService.freePositionsFromLocation(ubi).subscribe((response:any)=>{
      //console.log("Posiciones Disponibles: ", response.data);

      for(let pos of response.data){
        let p = {
          'location_id':ubi,
          'position_id':pos.id,
          'nombre_posicion': pos.attributes.name,
          'nombre_ubicacion': ubicacion.attributes.name
        }

        this.posicionesUbicacionSeleccionada.push(p);

      }

      this.alert = `Posiciones de ${ubicacion.attributes.name} Cargadas`;
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();

      //console.log("POSICIONES DISPONIBLES: ", this.posicionesUbicacionSeleccionada);

    })
    // for(let pos of this.posicionesDisponibles){
    //   if(pos.location_id == ubi){
    //     this.posicionesUbicacionSeleccionada.push(pos);
    //   }
    // }
    // console.log("UBICACIONES DISPONIBLES: ", this.posicionesUbicacionSeleccionada);
  }

  onPalletSeleccionado(){
    let pallet;
    pallet = this.palletsSeleccionados.filter(function(pallet) {
           return pallet.selected === true;
         })[0];
    return pallet;
  }

  onCambiarPosicionPallet(){
    //console.log("VERIFICAR QUE UNO SEA SELECTED TRUE: ", this.palletsSeleccionados);
     let posicion_id = this.formCambiarPosicion.get('posicion').value;
     let pallet = this.onPalletSeleccionado();
     //let posicion_a_desocupar = pallet.location;
     //console.log("PALLET SELECCIONADO:", pallet);
     //console.log("POSICION ANTIGUA: ", posicion_a_desocupar);


     if(posicion_id !== ''){
       //console.log("posicion_id_ENTRO", posicion_id);
       let posicion = this.posicionesUbicacionSeleccionada.filter(function(posicion) {
            return posicion.position_id === posicion_id;
          })[0];


       /*retorna el pallet que tenga el selected == true*/



      if(pallet != undefined){
        /*actualizando la ubicación del pallet*/
        pallet.location = posicion;

        //console.log("Posicion: ", posicion);
        //console.log("id_posición: ",posicion_id);
        //console.log("pallet a actualizar: ", pallet);
         this.formCambiarPosicion.setValue({
           'posicion':""
         });

         this.posicionesUbicacionSeleccionada = [];

         if(posicion.nombre_posicion !== 'S/P'){
           /*debo sacarla del array de posicionesDisponibles*/
           let index = 0;
           for(let p of this.posicionesUbicacionSeleccionada){
             if(p.position_id == posicion.position_id){
               //console.log("ENCONTRO");
               this.posicionesUbicacionSeleccionada.splice(index,1);
             }
             index++;
           }
         }

         //console.log("POSICION PALLETS ACTUALIZADA: ", this.palletsSeleccionados);

         // if(posicion_a_desocupar.nombre_posicion !== 'S/P'){
         //   this.posicionesDisponibles.push(posicion_a_desocupar);
         //   console.log("Posiciones Update: ", this.posicionesDisponibles);
         // }

         this.limpiarSelects();
      }
      else{
        //console.log("no se ha seleccionado un pallet");
        this.limpiarSelects();
      }

     }
  }

  onIngresarCajas(){
    this.pasoCaja = true;
    this.pasoPallet = false;
    this.pasoAsignarCajas = false;
    this.pasoConfirmar = false;
    // this.mostrarIngresarCaja = true;
    // this.pasoCaja = true;
    //
    // if(this.cajas.length > 0){
    //   this.mostrarSeleccionarPallet = true;
    // }
    // else{
    //   this.mostrarSeleccionarPallet = false;
    // }
    //
    // if(this.palletsSeleccionados.length > 0){
    //   this.mostrarConfirmarDevolucion = true;
    // }
    // else{
    //
    //    this.mostrarConfirmarDevolucion = false;
    // }
    //
    // this.pasoPallet = false;
    // this.pasoConfirmar = false;
  }

  onSeleccionarPallet(){
    this.pasoCaja = false;
    this.pasoPallet = true;
    this.pasoAsignarCajas = false;
    this.pasoConfirmar = false;
   //  this.mostrarSeleccionarPallet = true;
   //  this.pasoPallet = true;
   //
   //  if(this.cajas.length > 0){
   //      this.mostrarIngresarCaja = true;
   //      this.pasoCaja = false;
   //  }
   //
   //
   // if(this.palletsSeleccionados.length > 0){
   //   this.mostrarConfirmarDevolucion = true;
   // }
   // else{
   //
   //    this.mostrarConfirmarDevolucion = false;
   // }
   //  this.pasoConfirmar = false;
  }

  onAsignarCajas(){
    this.pasoCaja = false;
    this.pasoPallet = false;
    this.pasoAsignarCajas = true;
    this.pasoConfirmar = false;
    // this.mostrarIngresarCaja = true;
    // this.pasoCaja = false;
    // this.mostrarSeleccionarPallet = true;
    // this.pasoPallet = false;
    // this.mostrarConfirmarDevolucion = true;
    // this.pasoConfirmar = true;
  }

  onConfirmarDevolucion(){
    let mostrar = true;
    for(let pallet of this.palletsSeleccionados){
      if(pallet.location.location_id === ''){
        mostrar = false;
      }
    }

    if(mostrar){
      this.pasoCaja = false;
      this.pasoPallet = false;
      this.pasoAsignarCajas = false;
      this.pasoConfirmar = true;
    }
    else{
        this.mostrarAlert = true;
    }

  }

  buscarCaja(){
    let qr = this.formBuscar.get('codigoCaja').value;

    this.alert = "Realizando busqueda.";
    this.isopen = true;
    this._loaddata.loadChange(20);
    let variable = '';
    let guion = 0;
    let prefijopallet = '';
    let sufijocaja = '';
    let prefijo = 0;
    let sufijo = 0;

    /*Derrepente la pistola lee 3 caracteres raros*/
    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    /*P18-0000-131-*/
    if(qr.charAt(0) == 'P' && qr.charAt(3) == '-' && parseInt(qr.charAt(2)) < 9 && parseInt(qr.charAt(2)) > 0 && parseInt(qr.charAt(1)) < 9 && parseInt(qr.charAt(1)) > 0){
      //console.log("se ha ingresado un código de pallet");
    }
    else{
      for(let char of qr){
        if(char != '-'){
          variable += char
        }
        else if(guion == 0){
          prefijo = parseInt(variable);
          variable = '';
          guion = 1;
        }
        else if(guion == 1){
          sufijo = parseInt(variable);
          variable = '';
          guion = 2;
        }
      }

      if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
        this._stockService.getOneStockByDeleted(prefijo.toString(),sufijo.toString()).subscribe(
          (response:any) => {
            //console.log("AGREGAR CAJA RESPUESTA: ", response);

            if(this.ordenProduccionActual == ''){
              this.ordenProduccionActual = response.relationships.tag.data.relationships.production_order.data.attributes.number;
              this.cliente = response.relationships.tag.data.relationships.production_order.data.attributes.client;
              //console.log("GENERICA? ", this.ordenProduccionActual.indexOf("-0000"));
              if(this.ordenProduccionActual.indexOf("-0000") == 2){
                this.es_generica = true;
              }
              else{
                this.es_generica = false;
              }
            }


            if(response.relationships.tag.data.relationships.production_order.data.attributes.number === this.ordenProduccionActual){
              let agregar = false;

              if(this.cajas.length == 0){
                agregar = true
              }
              else{
                /*comprobando si la caja ya esta ingresada*/
                let  c = this.cajas.filter(function(caj){
                    return caj.tag_id === response.attributes.tag_id;
                  })[0];
                //console.log("CAJA?: ", c);
                if(c == undefined){
                  //console.log("ENTRO");
                  agregar = true;
                }
              }



              if(agregar){
                    //console.log("RESPUESTA UN STOCK: ", response);
                    let peso = 0;
                    let packing = 'Sin información.';
                    let qr = 'Sin información';

                    if(response.relationships.tag.data.attributes.code != null && response.relationships.tag.data.attributes.code != ''){
                      qr = response.relationships.tag.data.attributes.code;
                    }

                    if(response.relationships.tag.data.relationships.packing.data != null){
                      packing = response.relationships.tag.data.relationships.packing.data.id;
                    }

                    if(parseInt(response.relationships.tag.data.attributes.residue) != 0){
                      peso = parseInt(response.relationships.tag.data.attributes.residue);
                    }
                    else{
                      peso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
                    }
                    this.cajas.push({
                      'stock_id':response.id,
                      'tag_id':response.attributes.tag_id,
                      'position_id':response.attributes.position_id,
                      'pallet_id':response.attributes.pallet_id,
                      'reason_id':6,
                      'qr':response.relationships.tag.data.attributes.prefix+'-'+response.relationships.tag.data.attributes.suffix,
                      'peso':peso,
                      'producto':response.relationships.tag.data.relationships.product.data.attributes.code,
                      'op_id':response.relationships.tag.data.relationships.production_order.data.id,
                      'orden_produccion':response.relationships.tag.data.relationships.production_order.data.attributes.number
                    });

                    this.ordenProduccionActual = this.cajas[0].orden_produccion;
                    //console.log("ordenProduccionActual", this.ordenProduccionActual);

                    this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                    this.isopen = true;

                    if(this.palletsDisponibles.length == 0){
                      this.cargarTodosPalletsConDisponibilidad(this.ordenProduccionActual);
                      this._loaddata.loadChange(40);
                    }
                    else{
                      this._loaddata.loadChange(100);
                    }


                    //this.onClosedAutomatic();

                    this.borrarFormulario();
                    if(this.cajas.length > 0){
                      this.mostrarSeleccionarPallet = true;
                    }
                    //console.log("Cajas", this.cajas);
              }
              else{
                //console.log("caja ya esta ingresada");
                this.alert = 'Caja ya esta ingresada';
                this.isopen = true;
                this._loaddata.loadChange(100);
                this.onClosedAutomatic();
              }
            }
            else{
              this.alert = 'La caja no corresponde a la misma Orden de Producción de las cajas ingresadas';
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.borrarFormulario();
              this.onClosedAutomatic();
              //console.log(`No corresponde a la misma OP opactual = ${this.ordenProduccionActual} opcajaaagregar = ${response.relationships.tag.data.relationships.production_order.data.attributes.number}`)
            }


          },
          (error) => {
            this.alert = 'Caja no encontrada en el sistema.';
            this.isopen = true;
            this._loaddata.loadChange(100);
            this.onClosedAutomatic();
          }
        );
      }
      else{
        this.alert = "Codigo QR invalido.";
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      }
    }

  }

  quitarCaja(posicion:number){

    this.cajas.splice(posicion,1);
    if(this.cajas.length == 0){
      let resetear = true;
      for(let pal of this.palletsSeleccionados){
        if(pal.cajas.length > 0){
          resetear = false;
        }
      }

      if(resetear){
        this.ordenProduccionActual = '';
        this.palletsDisponibles = [];
        this.palletsSeleccionados = [];
        this.cajas = [];
        this.pasoCaja = true;
        this.pasoPallet = false;
        this.pasoAsignarCajas = false;
        this.pasoConfirmar = false;
      }

    }

    //console.log("orden Produccion: ", this.ordenProduccionActual);
  }

  quitarPallet(posicion:number){
    let pallet = this.palletsSeleccionados[posicion];
    if(pallet.cajas.length > 0){
      for(let caja of pallet.cajas){
        this.cajas.push(caja);
      }
    }

    this.palletsSeleccionados.splice(posicion,1);

    if(this.palletsSeleccionados.length == 0){
      this.mostrarConfirmarDevolucion = false
    }
    /*si el pallet es nuevo, permito que se pueda agregar un pallet nuevo a la pantalla*/
    if(pallet.nuevo == true){
      this.permitirNuevoPallet = true;
    }
  }

  quitarCajaPallet(posicion:number, pallet:any){
    let cajaQuitar = pallet.cajas[posicion];
    pallet.cajas.splice(posicion,1);
    pallet.amount = pallet.amount - 1;
    this.cajas.push(cajaQuitar);
    //console.log("posicion: ", posicion);
    //console.log("pallet: ", pallet);
  }

  onSelectedOldPallet(){
    let idPallet = this.formPalletsDisponibles.get('pallet').value;
    //console.log("ID PALLET: ",idPallet);
    let selectedPallet = this.palletsDisponibles.filter(function(item) {
                          return item.id === idPallet;
                        })[0];
    let agregar = false;
    if(this.palletsSeleccionados.length == 0){
      agregar = true;
    }
    else{

      let pallet_existe = this.palletsSeleccionados.filter(function(item){
        return item.pallet_id === idPallet;
      })[0];
      //console.log("PALLET_EXISTE: ", pallet_existe);

      if(pallet_existe == undefined){
        agregar = true;
      }
    }



    if(agregar == true){
      let location_id = '';
      let position_id = '';
      let nombre_posicion = 'Sin Posición';
      let nombre_ubicacion = 'Sin Ubicación';
      if(selectedPallet.relationships.position.data != null){
        location_id = selectedPallet.relationships.position.data.attributes.location_id;
        position_id = selectedPallet.relationships.position.data.id;
        nombre_posicion = selectedPallet.relationships.position.data.attributes.name;
        nombre_ubicacion = selectedPallet.relationships.position.data.attributes.location;
      }
      this.palletsSeleccionados.push({
        'pallet_id': selectedPallet.id,
        'amount': selectedPallet.attributes.amount,
        'location_old':{
                          'location_id':location_id,
                          'position_id':position_id,
                          'nombre_posicion':nombre_posicion,
                          'nombre_ubicacion':nombre_ubicacion
                      },
        'location':{
                      'location_id':location_id,
                      'position_id':position_id,
                      'nombre_posicion': nombre_posicion,
                      'nombre_ubicacion':nombre_ubicacion
                   },
        'numero':selectedPallet.attributes.number,
        'cajas':[],
        'selected':false,
        'nuevo':false
      });

      //console.log("PALLETS: ", this.palletsSeleccionados);
    }


    if(this.palletsSeleccionados.length > 0){
      this.mostrarConfirmarDevolucion = true;
    }
  }

  onPalletSelected(pallet:any){
    /*se recorre el array para ver el pallet seleccionado y dejarlo true o false*/
    for(let pal of this.palletsSeleccionados){

      if(pal.pallet_id === pallet.pallet_id){

        if(pal.selected == true){

          pal.selected = false;
        }
        else{

          pal.selected = true;
        }

      }
      else{
        pal.selected = false;
      }
    }

    if(pallet.nuevo == true || pallet.location.location_id === ''){
      //this.esnuevo;
      this.formCambiarUbicacion.get('ubicacion').enable();
      this.formCambiarPosicion.get('posicion').enable();
    }
    else if(pallet.nuevo == false || pallet.location.location_id === ''){
      //this.esnuevo = false;
      this.formCambiarUbicacion.get('ubicacion').disable();
      this.formCambiarPosicion.get('posicion').disable();
    }


    //pallet.selected = true;
    //console.log("PALLET SELECCIONADO: ", pallet);
    //console.log("PALLETS: ", this.palletsSeleccionados);
  }

  onAgregarCajaPallet(caja:any){
    let pallet = null;
    for(let pal of this.palletsSeleccionados){
      if(pal.selected == true){
        pallet = pal;
      }
    }

    if(pallet != null){

      if(pallet.amount < 90){
        var i = this.cajas.indexOf(caja);

        if ( i !== -1 ) {
            this.cajas.splice( i, 1 );
        }
        pallet.amount = pallet.amount + 1;
        pallet.cajas.push(caja);
        //console.log("pallet Actualizado: ", pallet);
      }
      else{
        //console.log("no puede agregar mas cajas al pallet");
      }

    }
    else{
      //console.log("No hay un pallet seleccionado");
    }

  }

  borrarFormulario(){
    this.formBuscar.reset();
    this.formBuscar.setValue({
      'codigoCaja': ''
    });
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
    },3000);
  }

  onClosed(){
    this.isopen = false;
  }

  limpiarSelects(){
    this.formCambiarPosicion.reset();
    this.formCambiarUbicacion.reset();
    this.formCambiarUbicacion.setValue({
      'ubicacion' : ""
    })
    this.formCambiarPosicion.setValue({
      'posicion': ""
    })
  }

  cerrarAlert(){
    this.mostrarAlert = false;
  }



  /**
  * Abre una nueva ventana para imprimir las etiquetas QR contenidas
  * en printContents, que a su vez esta relacionado con print-section del html.
  */

  private print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    //console.log("DOCUMENTO HTML: ",printContents);
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style></style>
        </head>
        <body onload="window.print();window.close()">
          ${printContents}
        </body>
      </html>`
    );
    popupWin.document.close();
    this.limpiar();
  }

  confirmar(){
    //console.log("ANTES: ",this.palletsSeleccionados);

    /*recorrer cada palet y actualizar los datos de la caja*/
    this.alert = 'Enviando información';
    this.isopen = true;
    this._loaddata.loadChange(30);
    //this.onClosedAutomatic();

    for(let pallet of this.palletsSeleccionados){
      let stocks = [];
      if(pallet.nuevo == true){
        /*se crea el pallet nuevo*/
        let prov = this._palletsService.transformData4(pallet.prefijo);
        // //console.log("JSON NUEVO PALLET", prov);
        this._palletsService.save(prov).subscribe((response:any)=>{
          this.alert = 'Pallet Nuevo Creado';
          this.isopen = true;
          this._loaddata.loadChange(40);

          //this.onClosedAutomatic();
          //console.log("RESPUESTA CREACIÓN DE PALLET: ",  response);
          this.palletsNuevos.push(response);

          this.myAngularxQrCode = response.attributes.qr_code;
          this.codigo = response.attributes.number;
          //console.log(`Cliente:${this.cliente}  QRCODE:${this.myAngularxQrCode}  NUMBER PALLET:${this.codigo}`);
          let that = this;
          setTimeout(function(){
          that.print();
          },100);

          // //this.codigo = response.attributes.number;


          /*por cada caja del pallet agrego los datos a enviar al arreglo stocks*/
          for(let caja of pallet.cajas){
            let c = {
              'stock_id':caja.stock_id,
              'tag_id':caja.tag_id,
              'pallet_id':response.id,
              'position_id': pallet.location.position_id,
              'reason_id':'6',
              'stock_status_id':'1',
            }
            stocks.push(c);
          }
         /*transformado las cajas a formato json*/
          let prov = this._stockService.transformDataDevolucion(stocks);
          //console.log("JSON DEVOLUCION STOCKS PALLET NUEVO: ", prov);
          this.alert = 'Almacenando Cajas en Pallet';
          this.isopen = true;
          this._loaddata.loadChange(60);
          this._stockService.saveAllDevolucion(prov).subscribe((response:any)=>{
            //console.log("RESPUESTA GUARDAR STOCKS DE PALLET NUEVO: ", response);
            this.alert = 'Cajas Almacenadas Satisfactoriamente';
            this.isopen = true;
            this._loaddata.loadChange(100);
            this.onClosedAutomatic();
            /*imprimiendo pallet nuevo*/



            /**/
          },(error)=>{
            //console.log("Ha ocurrido un error inesperado: ", error.error.error);
            this.alert='Las Cajas no han podido ser devueltas al sistema';
            this.isopen = true;
            this._loaddata.loadChange(100);
            this.onClosedAutomatic();
          });
          // this.myAngularxQrCode = response.attributes.qr_code;
          // this.codigo = response.attributes.number;
          // //this.codigo = response.attributes.number;
          // this.palletsSeleccionados.push({
          //                                   'pallet_id': response.id,
          //                                   'amount': response.attributes.amount,
          //                                   'location_old':{
          //                                                     'location_id':'',
          //                                                     'position_id':'',
          //                                                     'nombre_posicion': '',
          //                                                     'nombre_ubicacion':''
          //                                                 },
          //                                   'location':{
          //                                                 'location_id':'',
          //                                                 'position_id':'',
          //                                                 'nombre_posicion': '',
          //                                                 'nombre_ubicacion':''
          //                                              },
          //                                   'numero':response.attributes.number,
          //                                   'cajas':[],
          //                                   'selected':false,
          //                                   'nuevo':true
          //                                 });
          // console.log("PALLETS DISPONIBLES AL CREAR: ", this.palletsSeleccionados);
          //
          // /*por alguna razón se debe setear el that con el this ya que agarra toda la pagina al imprimir*/
          // let that = this;
          // setTimeout(function(){
          //   that.print();
          // },100);

          //this.alert = 'Pallet Nuevo Creado y agregado a la pantalla';
          //this.isopen = true;
          //this._loaddata.loadChange(100);
          //this.onClosedAutomatic();

          },error=>{
            //console.log("No se creó el pallet");
            this.alert = 'No se ha creado el pallet';
            this.isopen = true;
            this._loaddata.loadChange(100);
            this.onClosedAutomatic();
        });
      }
      else{
                /*el pallet no es nuevo*/
                for(let caja of pallet.cajas){
                  //console.log("CAJA STOCK: ", caja.stock_id);
                  let c = {
                    'stock_id':caja.stock_id,
                    'tag_id':caja.tag_id,
                    'pallet_id':pallet.pallet_id,
                    'position_id': pallet.location.position_id,
                    'reason_id':'6',
                    'stock_status_id':'1',
                  }
                  stocks.push(c);
                }

                /*transformado las cajas a formato json*/
                 let prov = this._stockService.transformDataDevolucion(stocks);
                 //console.log("JSON DEVOLUCION STOCKS PALLET EXISTENTE: ", prov);
                 this.alert = 'Almacenando Cajas en Pallet';
                 this.isopen = true;
                 this._loaddata.loadChange(60);
                 this._stockService.saveAllDevolucion(prov).subscribe((response:any)=>{
                   //console.log("RESPUESTA GUARDAR STOCKS DE PALLET VIEJO: ", response);
                   this.alert = 'Cajas Almacenadas Satisfactoriamente';
                   this.isopen = true;
                   this._loaddata.loadChange(100);
                   this.onClosedAutomatic();
                   this.limpiar();
                 },(error)=>{
                   //console.log("Ha ocurrido un error inesperado: ", error.error.error);
                   this.alert='Las Cajas no han podido ser devueltas al sistema';
                   this.isopen = true;
                   this._loaddata.loadChange(100);
                   this.onClosedAutomatic();
                 });
      }

    }

    // setTimeout(()=>{
    //
    // },5000)
    // this._stockService.saveAll(stocks).subscribe((response:any)=>{
    //
    // },(error)=>{
    //   console.log("ALGO SALIÓ MAL AL GUARDAR LOS STOCKS", error.error.error);
    // })

   //console.log("PALLETS NUEVOS CREADOS: ", this.palletsNuevos);

  //  console.log("STOCKS A ENVIAR: ", stocks);

  }

  limpiar(){
    this.mostrarIngresarCaja = true;
    this.mostrarSeleccionarPallet = false;
    this.mostrarConfirmarDevolucion = false;
    this.mostrarAlert = false;

    this.pasoCaja = true;
    this.pasoPallet = false;
    this.pasoAsignarCajas = false
    this.pasoConfirmar = false;
    this.esnuevo = false;
    this.permitirNuevoPallet = true;
    this.es_generica = false;

    this.isopen = false;
    this.alert = '';

    this.cajas = [];
    this.pallet = '';
    this.palletsDisponibles = [];
    this.palletsDisponiblesOrdenProduccion = [];
    this.palletsSeleccionados = [];
    this.palletsNuevos = [];

    this.ubicaciones = [];
    this.posicionesDisponibles = [];
    this.posicionesUbicacionSeleccionada = [];

    this.ordenProduccionActual = '';
    this.id_palletNuevo = 0;

    this.myAngularxQrCode = 'P18-0000-PRUEBA';
    this.codigo = '';
    this.cliente = '';

    this.formBuscar = new FormGroup({
      'codigoCaja': new FormControl('', Validators.required)
    });

    this.formPalletsDisponibles = new FormGroup({
      'pallet': new FormControl('', Validators.required)
    });

    this.formCambiarUbicacion = new FormGroup({
      'ubicacion': new FormControl('', Validators.required)
    });

    this.formCambiarPosicion = new FormGroup({
      'posicion': new FormControl('', Validators.required)
    });

    this.cargarUbicaciones();
  }

  agregarCajasRestantes(){
    let pallet = null;
    for(let pal of this.palletsSeleccionados){
      if(pal.selected == true){
        pallet = pal;
      }
    }
    if(pallet != null){
      for(let c of this.cajas){
        pallet.cajas.push(c);
        pallet.amount++;
      }
      this.cajas = [];
    }
  }


}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/devolucion/devolucion.component.ts